<template>
  <div class="user-status-filter-item keyword">
    <label
      class="item-label"
      v-t.preserve="'appUserStatusFilterKeyword.keyword'"
    />
    <input-keyword-user
      id-prefix="user-status-filter-keyword"
      v-model="modelValue"
      v-bind:keyword-targets="localValue.keywordTargets"
      v-on:keyword-changed="$_onKeywordChanged"
      v-on:keyword-target-changed="$_onKeywordTargetChanged"
    />
  </div>
</template>

<script>
import InputKeywordUser from '@/components/AppInputKeywordUser.vue'

export default {
  name: 'AppUserStatusFilterKeyword',
  components: {
    InputKeywordUser,
  },
  props: {
    /**
     * キーワード
     */
    keyword: {
      type: String,
      default: null,
    },
    /**
     * キーワード検索対象
     */
    keywordTargets: {
      type: Array,
      default: () => [],
    },
    /**
     * 入力中キーワード
     * @model
     */
    value: {
      type: String,
      default: null,
    },
  },
  emits: [
    /**
     * 選択値変更イベント
     * @param {Object} value 選択値
     * @param {String} text 選択値表示テキスト
     */
    'changed',
    /**
     * キーワード入力イベント
     * @param {string} keyword キーワード
     */
    'input',
  ],
  data: function () {
    return {
      // ローカル値
      localValue: {
        keyword: null,
        keywordTargets: [],
      },
    }
  },
  computed: {
    /**
     * v-model透過用
     * @type {String}
     */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    /**
     * イベント返却用のテキスト
     * @type {String}
     */
    resultText: function () {
      const { keyword, keywordTargets } = this.localValue
      if (keyword == null || keyword === '') return ''
      return keywordTargets.length
        ? `${keyword}(${keywordTargets.join(',')})`
        : keyword
    },
  },
  watch: {
    keyword: {
      immediate: true,
      handler: function (value) {
        this.localValue.keyword = value
      },
    },
    keywordTargets: {
      immediate: true,
      handler: function (value) {
        this.localValue.keywordTargets = value
      },
    },
    localValue: {
      deep: true,
      handler: function () {
        this.$_onChange()
      },
    },
  },
  mounted: function () {
    // 初回結果表示のためにpropsの値で変更されたことにする
    this.$_onChange()
  },
  methods: {
    /**
     * キーワード変更時処理
     * @param {string} keyword キーワード
     */
    $_onKeywordChanged: function (keyword) {
      this.localValue.keyword = keyword === '' ? null : keyword
      this.modelValue = this.localValue.keyword
    },
    /**
     * キーワード検索対象変更時処理
     * @param {string[]} keywordTargets キーワード検索対象
     */
    $_onKeywordTargetChanged: function (keywordTargets) {
      this.localValue = {
        // 検索対象変更時は検索をトリガーしたとみなして入力値も反映する
        keyword: this.modelValue === '' ? null : this.modelValue,
        keywordTargets,
      }
      // store にも保存
      this.$store.dispatch(
        'userKeywordTarget/setKeywordTargets',
        keywordTargets
      )
    },
    /**
     * 変更時処理
     */
    $_onChange: function () {
      /**
       * 選択値変更イベント
       * @param {Object} value 選択値
       * @param {String} text 選択値表示テキスト
       */
      this.$emit('changed', { value: this.localValue, text: this.resultText })
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../assets/scss/parts/user/user-status-filter-item';
</style>
